// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const CloudConfig = t.struct({
    availableCloudServices: t.list(t.String),
    baseUrl: t.String
}, {
    name: 'CloudConfig',
    strict: true
});

export const getDefaultState = () => new CloudConfig({
    availableCloudServices: [],
    baseUrl: ''
});

export default CloudConfig;



// WEBPACK FOOTER //
// ./src/shared/models/cloud-config.js